export default "__VITE_ASSET__DVWowGbz__"